import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {
  @Input() checked: boolean = false;
  @Input() iconName: string = '';
  @Input() svgSize: number = 22;
  @Input() circleSize: number = 32;
  @Input() matFontSize: number = 20;

  iconsFromSVG = [
    { iconName: 'whatsapp', fileName: 'whatsapp-icon.svg' },
    { iconName: 'twitter', fileName: 'twitter-icon.svg' },
    { iconName: 'youtube', fileName: 'youtube-icon.svg' },
    { iconName: 'instagram', fileName: 'instagram-icon.svg' },
    { iconName: 'facebook', fileName: 'facebook-icon.svg' },
    { iconName: 'inspira', fileName: 'mobile-icon.svg' },
    { iconName: 'activesoft', fileName: 'barcode-icon.svg' },
    { iconName: 'boletim-unimestre', fileName: 'boletim-unimestre-icon.svg' },
  ];
  iconsSVGpath = '../../../../../assets/icons/';

  constructor() {}

  get useImage() {
    const result = this.iconsFromSVG.some(
      (icon) => icon.iconName == this.iconName
    );
    return result;
  }

  get imagePath() {
    const result = this.iconsFromSVG.find(
      (icon) => icon.iconName == this.iconName
    );
    if (result) {
      return `${this.iconsSVGpath}${result.fileName}`;
    }
    return '';
  }

  ngOnInit(): void {}
}
